import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';


@Component({
  selector: 'app-eSignature',
  templateUrl: './eSignature.component.html',
  styleUrls: ['./eSignature.component.scss']
})

export class ESignatureComponent implements OnInit {

  permissionAsssign: any[] = [];
  folderList: any[] = [];
  
  constructor(private router: Router,private _dataSharingService: DataSharingService,
    private cdr: ChangeDetectorRef) { }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    //this.permissionAsssign = JSON.parse(sessionStorage.getItem("permissions"));   
    // this.permissionAsssign =this.permissionAsssign.filter((x) => x.permissionName.toLowerCase() == 'menu forms');
    // if(this.permissionAsssign.length == 0){
    //   this.router.navigate(['unauthorised']);
    //   return;
    // }

    this.permissionAsssign = JSON.parse(sessionStorage.getItem("menuModules"));  
    this.permissionAsssign =this.permissionAsssign.filter((x) => x.mainModuleName == 'Forms' && x.isAssign==true);
    if(this.permissionAsssign.length == 0){
      this.router.navigate(['unauthorised']);
      return;
    }

    sessionStorage.setItem('HeaderModuleName', "Forms"); 
    this._dataSharingService.sendSelectedModuleName("Forms");
    this.cdr.detectChanges();
  }
  
}
